
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'UnauthorizedView'
})
export default class UnauthorizedView extends Vue {}

